import React from "react"
import Helpers, { dateFormat, number_format } from "../../../../config/Helpers";
import { latest as API_URL } from "../../../../config/api";

export const api = {
    baseUrl : API_URL + "dynamic-request",
};

export const dialogOcupanccy = (data, self) => {
    let dialog = {
        container : "",
        buttons : ""
    }
    dialog.container = (
        <div className="type-cont inside">
            <span className="title" children={data["day"]} />
            <div>
                <span className="t-sto" />
                <span children={ data["t-sto"]["value"] + " (" + data["t-sto"]["percent"] + ")" } />
            </div>
            <div>
                <span className="t-ava" />
                <span children={ data["t-ava"]["value"] + " (" + data["t-ava"]["percent"] + ")" } />
            </div>
            <div>
                <span className="t-sold" />
                <span children={ data["t-sold"]["value"] + " (" + data["t-sold"]["percent"] + ")" } />
            </div>
            <div>
                <span className="t-oos" />
                <span children={ data["t-oos"]["value"] + " (" + data["t-oos"]["percent"] + ")" } />
            </div>
        </div>
    );
    return dialog;
}
export const wizardDate = (date) => {
    let format_date = date.year;
    if(date.month.key !== ""){
        format_date += " / " + date.month.value;
    }else if(date.day.key !== ""){
        format_date += " / " + date.month.value + " / " + date.day.value;
    }
    return format_date;
}


// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/occupancy/widgets/Production.js